import { Link, router, type Href } from 'expo-router';
import { ArrowLeftIcon } from 'lucide-react-native';
import type { ReactNode } from 'react';
import { Platform, View } from 'react-native';

import { Button } from '@sixam/ui/button';
import { Icon } from '@sixam/ui/icon';
import { Text } from '@sixam/ui/text';

export function PageHeaderRow({
  actions,
  backHref,
  subtitle,
  title,
}: Readonly<{
  actions?: ReactNode;
  backHref?: Href;
  subtitle?: string | null;
  title: string;
}>) {
  if (Platform.OS !== 'web') {
    return null;
  }

  const backButton = (
    <Button
      variant="ghost"
      size="icon"
      className="size-10"
      onPress={backHref ? undefined : () => router.back()}
    >
      <Icon as={ArrowLeftIcon} className="size-5" />
    </Button>
  );

  return (
    <View className="gap-3 sm:flex-row sm:items-center sm:justify-between">
      <View className="min-w-0 flex-1 flex-row items-center gap-3">
        {backHref ? (
          <Link href={backHref} asChild>
            {backButton}
          </Link>
        ) : (
          backButton
        )}
        <View className="min-w-0 flex-1 gap-1">
          <Text variant="h2" numberOfLines={2}>
            {title}
          </Text>
          {subtitle ? (
            <Text variant="muted" numberOfLines={1}>
              {subtitle}
            </Text>
          ) : null}
        </View>
      </View>
      {actions ? <View className="flex-row flex-wrap items-center gap-2">{actions}</View> : null}
    </View>
  );
}
